import { IReviewResponseDto } from './../../shared/models/responses/review.response';
import { Component, OnInit } from '@angular/core';
import { AuthenticationResult } from 'src/app/shared/models/authentication-result';
import { IReviewRequestDto } from 'src/app/shared/models/requests/review.request';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { DataService } from '../services/data-service.service';
import { WizardStore } from '../stores/wizard-store.service';

@Component({
  selector: 'app-close-wizard',
  templateUrl: './close-wizard.component.html',
  styleUrls: ['./close-wizard.component.scss']
})
export class CloseWizardComponent implements OnInit {
  user: AuthenticationResult = null;
  selectedCandidateId: string;
  jobReviews: IReviewResponseDto[] = [];
  isReviewGiven = false;
  constructor(private wizardStore: WizardStore,
    private uiState: UiStateStore,
    private dataService: DataService) {
    this.selectedCandidateId = this.wizardStore.getSelectedCandidateId();
    this.uiState.authenticatedUser.subscribe(resp => {
      this.user = resp;
    });
  }

  ngOnInit(): void {
    this.wizardStore.selectedCandidateAccountId.subscribe(accountId => {
      this.selectedCandidateId = accountId;
      this.getJobReviews(accountId);
    });
  }

  getJobReviews = (candidateAccountId: string) => {
    this.dataService.getJobReview(this.wizardStore.getSelectedJobId()).subscribe(resp => {
      this.isReviewGiven = resp.findIndex(x => x.reviewedBy == this.user.accountId && x.reviewedTo == candidateAccountId) > -1;
      this.jobReviews = resp.filter(x => x.reviewedTo == this.selectedCandidateId);
    });
  }

  onReviewSave = (request: IReviewRequestDto) => {
    request.reviewedTo = this.selectedCandidateId;
    request.jobId = this.wizardStore.getSelectedJobId();
    request.isClientReview = true;

    this.dataService.submitReview(request).subscribe(resp => {
      this.getJobReviews(this.selectedCandidateId);
      this.uiState.setSuccess("Review submitted successfully.");
    });
  };

}
